import { useState, useRef, useEffect } from 'react';
import { Button } from "semantic-ui-react";

export const ProgressiveText = ({ richText, expandText, expandComponentType }) => {
	const [expanded, setExpanded] = useState(false);
	const [showExpandButton, setShowExpandButton] = useState(false);
	const textRef = useRef(null);

	useEffect(() => {
		if (textRef.current && !expanded) {
			// Check if the content overflows
			const element = textRef.current;
			const isOverflowing = element.scrollHeight > element.clientHeight;
			setShowExpandButton(isOverflowing);
		}
	}, [richText, expanded]);

	return (
		<div className="relative w-full">
			<div
				ref={textRef}
				className={`overflow-hidden transition-all mb-4 ${expanded ? "max-h-1000" : "max-h-20"}`}
				style={{
					display: "-webkit-box",
					WebkitLineClamp: expanded ? "unset" : "3",
					WebkitBoxOrient: "vertical",
				}}
			>
				{richText}
			</div>

			{showExpandButton && (
				<ProgressiveTextExpand
					expanded={expanded}
					setExpanded={setExpanded}
					expandComponentType={expandComponentType}
					expandText={expandText}
				/>
			)}
		</div>
	);
};

export const ProgressiveTextExpand = ({ expanded, setExpanded, expandComponentType, expandText }) => {
	if (expanded) return null;
	switch (expandComponentType) {
		case "link":
			return (
				<span
					className="text-is2-blue-500 underline inline-block cursor-pointer"
					onClick={e => {
						e.preventDefault();
						setExpanded(true);
					}}
				>
					{expandText ?? "Keep reading"}
				</span>
			);
		case "button":
		default:
			return (
				<Button
					secondary={true}
					className=" !text-black hover:underline !border-2 !border-solid !border-is2-gray-200 mt-8"
					onClick={() => setExpanded(true)}
				>
					{expandText ?? "Keep reading"}
				</Button>
			);
	}
};
